// extracted by mini-css-extract-plugin
module.exports = {"button":"_9e1425b4d3--button--haBUr","icon":"_9e1425b4d3--icon--LsF_Z","XS":"_9e1425b4d3--XS--YvAr8","M":"_9e1425b4d3--M--PmIWC"};